export enum SurveyLogicBuilderStatus {
  CLOSED = 'closed',
  OPENED = 'opened',
}
